import { render, staticRenderFns } from "./CardTarjaDefault.vue?vue&type=template&id=d4ebabc4&scoped=true"
import script from "./CardTarjaDefault.vue?vue&type=script&lang=js"
export * from "./CardTarjaDefault.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaDefault.vue?vue&type=style&index=0&id=d4ebabc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ebabc4",
  null
  
)

export default component.exports